import { Box } from "@chakra-ui/react";
import { usePage, Head } from "@inertiajs/react";
import { PageProps as InertiaPageProps } from "@inertiajs/core";
import Header from "./Header";
import Footer from "./Footer";
import { toaster, Toaster } from "./ui/toaster";
import { useGoogleAnalytics } from "../hooks/useGoogleAnalytics";

interface LayoutProps {
  children: React.ReactNode;
}

interface PageProps extends InertiaPageProps {
  flash?: {
    notice?: string;
    alert?: string;
  };
}

export default function Layout({ children }: LayoutProps) {
  const page = usePage<PageProps>();
  const url =  window.location.origin + usePage().url;
  const { flash } = page.props;

  useGoogleAnalytics();

  if (flash?.notice) {
    requestAnimationFrame(() => {
      toaster.create({
        title: flash.notice,
        type: "success",
        duration: 3000,
        closable: true,
      });
    });
  }

  if (flash?.alert) {
    requestAnimationFrame(() => {
      toaster.create({
        title: flash.alert,
        type: "error",
        duration: 3000,
        closable: true,
      });
    });
  }

  const description = "だれでも、どこでも、バスケができる場所と仲間を見つけられるアプリ";
  const keywords = "OPEN COURT,オープンコート,バスケットボール,1on1,レーティング,ランキング"

  return (
    <>
      <Head>
        <meta head-key="description" name="description" content={description} />
        <meta head-key="keywords" name="keywords" content={keywords} />

        <meta head-key="og-type" property="og:type" content="website" />
        <meta head-key="og-url" property="og:url" content={url} />
        <meta head-key="og-title" property="og:title" content="OPEN COURT" />
        <meta head-key="og-description" name="og:description" content={description} />
        <meta head-key="og-image" property="og:image" content="/icons/logo_color.svg" />
        <meta head-key="og-locale" property="og:locale" content="ja_JP" />
        <meta head-key="og-site_name" property="og:site_name" content="OPEN COURT" />

        <meta head-key="twitter-card" name="twitter:card" content="summary_large_image" />
        <meta head-key="twitter-image" name="twitter:image" content="/icons/logo_color.svg" />
        <link rel="canonical" href={url} />

        <meta head-key="robots" name="robots" content="noindex,nofollow" />
      </Head>

      <div className="layout">
        <Header />
        <Box as="main" bg="gray.100" color="gray.800" style={{ minHeight: "calc(100vh - (var(--spacing) * 16))" }} pb={16}>
          {children}
        </Box>
        <Footer />
        <Toaster />
      </div>
    </>
  );
}
